import { useMemo } from 'react';
import moment from '@g4/moment-utc';
import get from 'lodash/get';

import { useSSRQuery } from '../../graphql';
import MARKET_QUERY from './useMarketQuery/flightMarket.query.graphql.js';
import { DEPARTING, RETURNING } from './constants';

const getLatestDate = datesArray =>
  datesArray
    ? moment.max(datesArray.map(d => moment(d.date))).format('YYYY-MM-DD')
    : null;
const getEarliestDate = datesArray =>
  datesArray
    ? moment.min(datesArray.map(d => moment(d.date))).format('YYYY-MM-DD')
    : null;

const useMarketQuery = searchCriteria => {
  const { data: marketQueryData, ...marketQuery } = useSSRQuery(MARKET_QUERY, {
    variables: {
      origin: searchCriteria.origin,
      destination: searchCriteria.destination,
    },
    skip: !searchCriteria.origin || !searchCriteria.destination,
  });

  const lastAvailableDates = useMemo(
    () => ({
      [DEPARTING]: getLatestDate(
        get(marketQueryData, 'flightMarket.calendar.departingDates')
      ),
      [RETURNING]: getLatestDate(
        get(marketQueryData, 'flightMarket.calendar.returningDates')
      ),
    }),
    [marketQueryData]
  );
  const earliestAvailableDates = useMemo(
    () => ({
      [DEPARTING]: getEarliestDate(
        get(marketQueryData, 'flightMarket.calendar.departingDates')
      ),
      [RETURNING]: getEarliestDate(
        get(marketQueryData, 'flightMarket.calendar.returningDates')
      ),
    }),
    [marketQueryData]
  );

  return { earliestAvailableDates, lastAvailableDates, ...marketQuery };
};

export default useMarketQuery;
